














import { Vue, Component } from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import Button from "@/shared/components/ui/Button.vue";
import PdfFormSignature from "@/employee/components/PdfFormSignature.vue";
import { PdfFormSignatureModel, TrusteeToTrusteeBalanceTransferSignatureSaveRequest } from "@/shared/types";

@Component({
  components: {
    Button,
    GenericLoadingSpinner,
    PdfFormSignature
  }
})
export default class TrusteeToTrusteeTransferFormSignature extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  goToNextStep () {
    this.balanceTransferStore.goToStep("trustee-finish");
  }

  goToPreviousStep () {
    this.balanceTransferStore.goToStep("trustee-details");
  }

  mounted () {
    if (!this.isLoaded) {
      this.balanceTransferStore.goToStart();
    }
  }

  get isLoaded () {
    return this.balanceTransferStore.eSignModelLoaded;
  }

  get documentUrl () {
    return this.balanceTransferStore.eSignModel.documentUrl;
  }

  saveSignature (model: PdfFormSignatureModel) {
    const saveRequest: TrusteeToTrusteeBalanceTransferSignatureSaveRequest = {
      requestId: this.balanceTransferStore.eSignModel.requestId,
      signatureBase64Image: model.signatureBase64Image,
      captureName: model.captureName,
      signingDate: model.signingDate
    };
    return this.balanceTransferStore.signTrusteeToTrusteeBalanceTransferForm(saveRequest)
    .then(() => {
      this.goToNextStep();
    });
  }
}
